import { useContext } from 'react';

import {
  CookieConsentContext,
  type CookieConsentContextValue,
} from '../context/CookieConsentContext';

export function useCookieConsent(): CookieConsentContextValue {
  const ctx = useContext(CookieConsentContext);
  if (!ctx) {
    throw new Error('useCookieConsent deve essere usato dentro <CookieConsentProvider>');
  }
  return ctx;
}
